import React from "react";
import { today } from "../../utils/dateUtils";
import css from "./auth.module.scss";


interface IProps {
  className?: string;
}

export const Copyright: React.FC<IProps> = ({ className }) => {
  return (
    <div className={className || css.copyrightText}>
      © {today().getFullYear()} Carestream Dental LLC
    </div>
  );
};
